import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const WorkflowWebhookMissing = ({ height = 105, width = 111, ...props }: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      d="M0.763184 53.5223C0.763183 60.2459 2.08751 66.9038 4.66055 73.1157C7.23359 79.3275 11.005 84.9718 15.7593 89.7261C20.5137 94.4805 26.1579 98.2519 32.3698 100.825C38.5817 103.398 45.2395 104.722 51.9632 104.722C58.6869 104.722 65.3447 103.398 71.5566 100.825C77.7684 98.2519 83.4127 94.4805 88.167 89.7261C92.9214 84.9718 96.6928 79.3275 99.2658 73.1157C101.839 66.9038 103.163 60.2459 103.163 53.5223C103.163 46.7986 101.839 40.1407 99.2658 33.9289C96.6928 27.717 92.9214 22.0728 88.167 17.3184C83.4127 12.564 77.7684 8.79267 71.5566 6.21963C65.3447 3.64659 58.6869 2.32227 51.9632 2.32227C45.2395 2.32227 38.5817 3.64659 32.3698 6.21963C26.1579 8.79267 20.5137 12.564 15.7593 17.3184C11.005 22.0728 7.23359 27.717 4.66055 33.9289C2.08751 40.1407 0.763183 46.7986 0.763184 53.5223Z"
      fill="#F5F4F4"
    />
    <path
      d="M36.4829 92.2423C36.4829 92.7515 37.9663 93.2398 40.6068 93.5999C43.2474 93.96 46.8287 94.1623 50.5629 94.1623C54.2972 94.1623 57.8785 93.96 60.519 93.5999C63.1595 93.2398 64.6429 92.7515 64.6429 92.2423C64.6429 91.733 63.1595 91.2447 60.519 90.8846C57.8785 90.5245 54.2972 90.3223 50.5629 90.3223C46.8287 90.3223 43.2474 90.5245 40.6068 90.8846C37.9663 91.2447 36.4829 91.733 36.4829 92.2423Z"
      fill="#E0DEDF"
    />
    <path
      d="M74.0073 75.077C74.1041 75.641 73.973 76.2204 73.6427 76.6878C73.3124 77.1551 72.81 77.4722 72.246 77.5691L21.1881 86.364C20.9099 86.4116 20.625 86.4037 20.3498 86.3407C20.0747 86.2776 19.8147 86.1608 19.5849 85.9968C19.3552 85.8328 19.1601 85.625 19.0111 85.3853C18.862 85.1456 18.7619 84.8788 18.7164 84.6002L7.77752 21.0968C7.68063 20.533 7.81159 19.9537 8.14162 19.4864C8.47165 19.0191 8.97374 18.7019 9.53752 18.6047L60.575 9.81362C60.8542 9.76546 61.1403 9.77277 61.4167 9.83516C61.6932 9.89754 61.9547 10.0138 62.1862 10.1772C62.4177 10.3406 62.6148 10.5481 62.7662 10.7877C62.9175 11.0273 63.0202 11.2943 63.0684 11.5736L74.0073 75.077Z"
      fill="white"
    />
    <path
      d="M64.4994 19.8821L63.0684 11.5736C63.0202 11.2943 62.9175 11.0273 62.7662 10.7877C62.6148 10.5481 62.4177 10.3406 62.1862 10.1772C61.9547 10.0138 61.6932 9.89754 61.4167 9.83516C61.1403 9.77277 60.8542 9.76546 60.575 9.81362L9.53752 18.6047C8.97374 18.7019 8.47165 19.0191 8.14162 19.4864C7.81159 19.9537 7.68063 20.533 7.77752 21.0968L9.20856 29.4053L64.4994 19.8821Z"
      fill="#E6FBFF"
    />
    <path
      d="M24.6838 51.5195L60.0694 45.5342"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8492 32.4549L57.0827 26.2008C57.4972 26.1293 57.9231 26.2253 58.2668 26.4678C58.6104 26.7103 58.8437 27.0794 58.9152 27.4939L60.1882 34.869C60.2598 35.2835 60.1637 35.7094 59.9212 36.0531C59.6787 36.3967 59.3096 36.63 58.8952 36.7015L22.6604 42.9558C22.2462 43.0273 21.8207 42.9313 21.4773 42.689C21.1339 42.4467 20.9008 42.0779 20.8293 41.6638L19.5561 34.2874C19.4846 33.8729 19.5806 33.447 19.8231 33.1033C20.0656 32.7597 20.4347 32.5264 20.8492 32.4549Z"
      fill="#E6FBFF"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6064 62.6809L61.992 56.6943"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5291 73.8407L63.9147 67.8555"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.20862 29.406L64.4995 19.8828"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3079 23.4482C11.3079 24.0338 11.5405 24.5954 11.9546 25.0095C12.3686 25.4236 12.9303 25.6562 13.5159 25.6562C14.1015 25.6562 14.6631 25.4236 15.0772 25.0095C15.4912 24.5954 15.7239 24.0338 15.7239 23.4482C15.7239 22.8626 15.4912 22.301 15.0772 21.8869C14.6631 21.4729 14.1015 21.2402 13.5159 21.2402C12.9303 21.2402 12.3686 21.4729 11.9546 21.8869C11.5405 22.301 11.3079 22.8626 11.3079 23.4482Z"
      fill="white"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3657 22.2324C18.3657 22.818 18.5984 23.3796 19.0124 23.7937C19.4265 24.2078 19.9881 24.4404 20.5737 24.4404C21.1593 24.4404 21.7209 24.2078 22.135 23.7937C22.5491 23.3796 22.7817 22.818 22.7817 22.2324C22.7817 21.6468 22.5491 21.0852 22.135 20.6711C21.7209 20.257 21.1593 20.0244 20.5737 20.0244C19.9881 20.0244 19.4265 20.257 19.0124 20.6711C18.5984 21.0852 18.3657 21.6468 18.3657 22.2324Z"
      fill="white"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.4236 21.0166C25.4236 21.6022 25.6562 22.1638 26.0703 22.5779C26.4844 22.992 27.046 23.2246 27.6316 23.2246C28.2172 23.2246 28.7788 22.992 29.1929 22.5779C29.607 22.1638 29.8396 21.6022 29.8396 21.0166C29.8396 20.431 29.607 19.8694 29.1929 19.4553C28.7788 19.0412 28.2172 18.8086 27.6316 18.8086C27.046 18.8086 26.4844 19.0412 26.0703 19.4553C25.6562 19.8694 25.4236 20.431 25.4236 21.0166Z"
      fill="white"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.0073 75.077C74.1041 75.641 73.973 76.2204 73.6427 76.6878C73.3124 77.1551 72.81 77.4722 72.246 77.5691L21.1881 86.364C20.9099 86.4116 20.625 86.4037 20.3498 86.3407C20.0747 86.2776 19.8147 86.1608 19.5849 85.9968C19.3552 85.8328 19.1601 85.625 19.0111 85.3853C18.862 85.1456 18.7619 84.8788 18.7164 84.6002L7.77752 21.0968C7.68063 20.533 7.81159 19.9537 8.14162 19.4864C8.47165 19.0191 8.97374 18.7019 9.53752 18.6047L60.575 9.81362C60.8542 9.76546 61.1403 9.77277 61.4167 9.83516C61.6932 9.89754 61.9547 10.0138 62.1862 10.1772C62.4177 10.3406 62.6148 10.5481 62.7662 10.7877C62.9175 11.0273 63.0202 11.2943 63.0684 11.5736L74.0073 75.077Z"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.0642 39.4629L81.9907 32.1275L90.5459 35.5407L87.6194 42.8761L79.0642 39.4629Z"
      fill="white"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.921 40.6555C108.218 41.1727 109.256 42.1838 109.807 43.4664C110.358 44.7489 110.377 46.1979 109.86 47.4945C109.343 48.7912 108.332 49.8292 107.049 50.3804C105.767 50.9315 104.318 50.9506 103.021 50.4334L88.355 44.5813C88.0309 44.4517 87.7716 44.1988 87.6338 43.8782C87.4961 43.5576 87.4912 43.1954 87.6202 42.8712L90.545 35.5381C90.6746 35.214 90.9275 34.9547 91.2481 34.8169C91.5687 34.6792 91.9309 34.6743 92.2551 34.8033L106.921 40.6555Z"
      fill="#E6FBFF"
    />
    <path
      d="M106.921 40.6555C108.218 41.1727 109.256 42.1838 109.807 43.4664C110.358 44.7489 110.377 46.1979 109.86 47.4945C109.343 48.7912 108.332 49.8292 107.049 50.3804C105.767 50.9315 104.318 50.9506 103.021 50.4334L88.355 44.5813C88.0309 44.4517 87.7716 44.1988 87.6338 43.8782C87.4961 43.5576 87.4912 43.1954 87.6202 42.8712L90.545 35.5381C90.6746 35.214 90.9275 34.9547 91.2481 34.8169C91.5687 34.6792 91.9309 34.6743 92.2551 34.8033L106.921 40.6555Z"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2585 26.7702C33.2585 30.0852 33.9115 33.3677 35.18 36.4303C36.4486 39.4929 38.308 42.2756 40.652 44.6196C42.996 46.9637 45.7788 48.823 48.8414 50.0916C51.904 51.3602 55.1865 52.0131 58.5014 52.0131C61.8164 52.0131 65.0989 51.3602 68.1615 50.0916C71.2241 48.823 74.0068 46.9637 76.3508 44.6196C78.6949 42.2756 80.5542 39.4929 81.8228 36.4303C83.0914 33.3677 83.7443 30.0852 83.7443 26.7702C83.7443 23.4553 83.0914 20.1728 81.8228 17.1102C80.5542 14.0476 78.6949 11.2648 76.3508 8.92081C74.0068 6.5768 71.2241 4.71742 68.1615 3.44884C65.0989 2.18027 61.8164 1.52734 58.5014 1.52734C55.1865 1.52734 51.904 2.18027 48.8414 3.44884C45.7788 4.71742 42.996 6.5768 40.652 8.92081C38.308 11.2648 36.4486 14.0476 35.18 17.1102C33.9115 20.1728 33.2585 23.4553 33.2585 26.7702Z"
      fill="white"
    />
    <path
      d="M38.9555 30.1358C39.8481 35.3197 42.7635 39.9367 47.0602 42.9711C51.357 46.0055 56.6832 47.2087 61.8671 46.3161C67.051 45.4235 71.668 42.5081 74.7024 38.2114C77.7368 33.9146 78.94 28.5884 78.0474 23.4045C77.1548 18.2206 74.2394 13.6036 69.9426 10.5692C65.6459 7.53483 60.3197 6.33159 55.1358 7.22421C49.9519 8.11683 45.3349 11.0322 42.3005 15.3289C39.2661 19.6257 38.0629 24.9519 38.9555 30.1358Z"
      fill="#F5F4F4"
    />
    <path
      d="M70.1084 10.6868C67.7184 8.96375 64.9747 7.79464 62.0764 7.26438C59.1782 6.73413 56.1983 6.85603 53.353 7.62124C50.5078 8.38644 47.8687 9.77575 45.6275 11.6882C43.3862 13.6007 41.599 15.9884 40.3958 18.6778L70.5922 13.4772L70.1084 10.6868Z"
      fill="#E6FBFF"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.5886 13.4775L40.3959 18.6782C39.183 21.3845 38.5954 24.3293 38.6769 27.2939C38.7032 28.247 38.7978 29.1971 38.9598 30.1367C39.6321 34.0168 41.4439 37.6091 44.1644 40.4561C46.8849 43.3032 50.3912 45.2762 54.2367 46.1241C58.0823 46.972 62.0931 46.6563 65.7587 45.2172C69.4242 43.7782 72.5786 41.2809 74.8203 38.0433L70.5886 13.4775Z"
      fill="white"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.8988 36.2382L62.916 24.7272C62.8444 24.3126 62.6111 23.9434 62.2674 23.7007C61.9237 23.4581 61.4977 23.3618 61.0831 23.4331L38.6729 27.2936C38.6992 28.2468 38.7937 29.1968 38.9557 30.1365C39.6858 34.4077 41.7996 38.3205 44.9717 41.2725L63.5996 38.0635C64.0137 37.9933 64.3831 37.7617 64.6266 37.4195C64.8702 37.0773 64.9681 36.6525 64.8988 36.2382Z"
      fill="#E6FBFF"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.9555 30.1358C39.8481 35.3197 42.7635 39.9367 47.0602 42.9711C51.357 46.0055 56.6832 47.2087 61.8671 46.3161C67.051 45.4235 71.668 42.5081 74.7024 38.2114C77.7368 33.9146 78.94 28.5884 78.0474 23.4045C77.1548 18.2206 74.2394 13.6036 69.9426 10.5692C65.6459 7.53483 60.3197 6.33159 55.1358 7.22421C49.9519 8.11683 45.3349 11.0322 42.3005 15.3289C39.2661 19.6257 38.0629 24.9519 38.9555 30.1358V30.1358Z"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2585 26.7702C33.2585 30.0852 33.9115 33.3677 35.18 36.4303C36.4486 39.4929 38.308 42.2756 40.652 44.6196C42.996 46.9637 45.7788 48.823 48.8414 50.0916C51.904 51.3602 55.1865 52.0131 58.5014 52.0131C61.8164 52.0131 65.0988 51.3602 68.1615 50.0916C71.2241 48.823 74.0068 46.9637 76.3508 44.6196C78.6949 42.2756 80.5542 39.4929 81.8228 36.4303C83.0914 33.3677 83.7443 30.0852 83.7443 26.7702C83.7443 23.4553 83.0914 20.1728 81.8228 17.1102C80.5542 14.0476 78.6949 11.2648 76.3508 8.92081C74.0068 6.5768 71.2241 4.71742 68.1615 3.44884C65.0988 2.18027 61.8164 1.52734 58.5014 1.52734C55.1865 1.52734 51.904 2.18027 48.8414 3.44884C45.7788 4.71742 42.996 6.5768 40.652 8.92081C38.308 11.2648 36.4486 14.0476 35.18 17.1102C33.9115 20.1728 33.2585 23.4553 33.2585 26.7702V26.7702Z"
      stroke="#2489A9"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
